export var FacebookPagesErrorType;
(function (FacebookPagesErrorType) {
    FacebookPagesErrorType[FacebookPagesErrorType["UNKNOWN"] = 0] = "UNKNOWN";
    FacebookPagesErrorType[FacebookPagesErrorType["BAD_TOKEN"] = 1] = "BAD_TOKEN";
    FacebookPagesErrorType[FacebookPagesErrorType["MAINTENANCE"] = 10] = "MAINTENANCE";
})(FacebookPagesErrorType || (FacebookPagesErrorType = {}));
//# sourceMappingURL=facebook-page-token-status.i.js.map